
<template>
<div class="DotUnread" ></div>
</template>

<style scoped lang="scss">
.DotUnread{
    --size: 12px;
    max-height: var(--size);
    max-width: var(--size);
    min-height: var(--size);
    min-width: var(--size);
    border: 3px solid var(--link-silent-middle);
    border-radius: 50%;
    background-color: var(--link);
    position: absolute;
    right: -3px;
    top: -3px;
    z-index: 3;

    @media (max-width: 576px) {
      right: 3px;
    }
}
</style>
